<div *ngIf="isVisible" class='popover-wrapper'>

  <div *ngIf="!popOverOpen" (mouseenter)="onMouseEnter(collapsedButton)"
    class="button-container collapsedButton-{{uniqueId}}" [class.toolbar-item-disabled]="collapsedButton.isDisabled()">

    <div class="hd-icon {{collapsedButton.icon()}} {{collapsedButton.cssClass()}} icon-lg" [soti-tooltip]="collapsedButton.tooltip()"
    placement="left">
    </div>

    <div *ngIf="expandedButtonsVisibleCount > 1"
      class="hd-icon hd-icon-toolbarpointer icon-lg toolbarpointer-icon scale50-with-same-origin {{collapsedButtonClass}}">
    </div>

  </div>

  <ng-container *ngIf="popOverOpen">
    <div class="popover-container popover-container-box {{expandedButtonsShadowClass}}">
      <ng-container *ngFor="let item of expandedButtons" [ngSwitch]="item.type">

        <ng-container *ngSwitchCase="WorkPanelBarItemType.Button">
          <div [hidden]="item.isVisible && !item.isVisible()"
            class="hd-icon {{item.icon()}} icon-lg popover-button-icon"
            [class.toolbar-item-disabled]="item.isDisabled()"
            (mouseenter)="onMouseEnter(item);"
            [soti-tooltip]="overTooltip"
            [placement]="expandedButtonsVisibleCount > 1 ? 'top' : 'left'"
            (click)="onClick(item)">
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="WorkPanelBarItemType.Icon">
          <div [hidden]="item.isVisible && !item.isVisible()"
            class="hd-icon {{item.icon()}} icon-lg popover-icon">
          </div>
        </ng-container>

      </ng-container>
    </div>
  </ng-container>
</div>
